import React		from "react";
import classNames	from "classnames";

import {
	TextField,
	Select,
	PrimaryButton,
	SecondaryButton,
	InvertedSecondaryButton,
	ButtonsBlock,
} from '../../Ui'

import Icon			from "../../common/components/Icon";
import Form			from "../../utils/Form";
import RadioButton	from "../../common/components/form/RadioButton";
import Switch		from "../../common/components/form/Switch";
import Slider		from "../../common/components/form/Slider";
import Tooltip		from "../../common/components/form/Tooltip";
import Cylinder		from "./Cylinder";

const twoEntriesCylinderImg	= require("../../../assets/cylindre-deux-entrees.png");
const buttonCylinderImg		= require("../../../assets/cylindre-bouton.png");
const demiCylinder			= require("../../../assets/cylindre-demi.png");

const LockingForm = ({
	lockingId,
	canDelete,
	name,
	onNameChange,
	isLocking,
	inGroupOptions,
	parentLockingId,
	onInGroupChange,
	cylinder_type_id,
	onCylinderTypeChange,
	disengageable,
	cylinderDimensions,
	onDisengageableChange,
	dimensionA,
	onDimensionAChange,
	dimensionB,
	onDimensionBChange,
	onDimensionBlur,
	onDelete,
	onDuplicate,
	onSubmit
}) =>
	<div className="c-locking-form">

		<ButtonsBlock>
			<InvertedSecondaryButton
				iconName="bin"
				disabled={!canDelete}
				onClick={onDelete}
			>
				Supprimer
			</InvertedSecondaryButton>
			<SecondaryButton
				iconName="duplicate"
				disabled={!lockingId}
				onClick={onDuplicate}>

				Dupliquer
			</SecondaryButton>
		</ButtonsBlock>

		<Form onSubmit={onSubmit}>
			<header className="c-locking-form__field-header">Nom {isLocking ? "de l'ouverture" : "du groupe"}</header>
			<div className="c-locking-form__field">
				<TextField
					placeholder="Ex : Entrée mairie"
					value={name}
					onChange={onNameChange} />
			</div>
			{isLocking ?
				<div>
					<header className="c-locking-form__field-header">Placer dans</header>
					<div className="c-locking-form__field">
						<Select
							options={inGroupOptions}
							value={parentLockingId}
							onChange={onInGroupChange} />
					</div>
					<header className="c-locking-form__field-header">Type de cylindre</header>
					<div className="c-locking-form__field c-locking-form__cylinder-choice" onClick={() => onCylinderTypeChange(1)}>
						<RadioButton
							onChange={() => null}
							value={1}
							checked={cylinder_type_id === 1} />
						<img className="c-locking-form__cylinder-img" src={twoEntriesCylinderImg} />
						<span>Cylindre 2 entrées</span>
						<span className="u-flex--inline flex-item-align-right">
							<Tooltip bottom left>
								Le cylindre 2 entrées (cylindre double entrée, 2E ou DE) permet à l’utilisateur d’insérer une clé de chaque côté du cylindre.
								<br />
								L’utilisateur peut ainsi verrouiller ou déverrouiller un accès peu importe s’il se situe à l’intérieur ou à l’extérieur.
								<br />
								La dimension la plus classique est le cylindre à double entrées 30 x 30 mm permettant d’être adapté sur des serrures à larder de porte d’épaisseur 40 mm.
							</Tooltip>
						</span>
					</div>
					<div className="c-locking-form__field c-locking-form__cylinder-choice" onClick={() => onCylinderTypeChange(2)}>
						<RadioButton
							value={2}
							checked={cylinder_type_id === 2}
							onChange={onCylinderTypeChange} />
						<img className="c-locking-form__cylinder-img" src={buttonCylinderImg} />
						<span>Cylindre à bouton</span>
						<span className="u-flex--inline flex-item-align-right">
							<Tooltip left>
								Le cylindre à bouton (cylindre double à bouton, BT) permet à l’utilisateur de verrouiller un accès de l’intérieur sans disposer de clé.
								<br />
								Les cylindres à bouton ne sont pas réversibles puisque le bouton est toujours situé côté intérieur.
								<br />
								Attention, il est déconseillé d’installer un cylindre double à bouton sur une porte en verre pour des raisons de sécurité à moins qu’elle ne soit blindée.
							</Tooltip>
						</span>
					</div>
					<div className="c-locking-form__field c-locking-form__cylinder-choice" onClick={() => onCylinderTypeChange(3)}>
						<RadioButton
							value={3}
							checked={cylinder_type_id === 3}
							onChange={onCylinderTypeChange} />
						<img className="c-locking-form__cylinder-img" src={demiCylinder} />
						<span>Demi-cylindre</span>
						<span className="u-flex--inline flex-item-align-right">
							<Tooltip left>
								Le demi-cylindre (½ cylindre, ½ cyl.) permet d’insérer une clé d’un seul côté.
								<br />
								Il est le plus souvent installé sur des portes de placards, certaines portes de caves ou de garage (basculantes, etc.) ou sur des serrures antipanique.
							</Tooltip>
						</span>
					</div>
					<div className="c-locking-form__field">
						<label>Fonction débrayable</label>
						<Switch
							checked={disengageable}
							disabled={cylinder_type_id === 3}
							onChange={onDisengageableChange} />
						<span className="u-flex--inline flex-item-align-right">
							<Tooltip bottom left>
								Fonction débrayable ou Clé de secours ou Synkro. Cette option permet d’ouvrir une porte de l’extérieur même si la clé est restée dans la serrure côté intérieur.  Elle est fortement conseillée dans des lieux publics comme les crèches, les EHPAD ou autres établissements accueillant des personnes âgées ou à mobilité réduite.
							</Tooltip>
						</span>
					</div>
					<header className="c-locking-form__field-header u-flex u-flex--align-items-center mb-1">
						Dimensions du cylindre
						<span className="u-flex--inline flex-item-align-right">
							<Tooltip bottom left>
								Les dimensions d’un cylindre se mesurent de chaque côté à partir de l’axe du panneton. Vous devez donc indiquer la dimension extérieure et intérieure. Dans le cas d’un cylindre à bouton, ce dernier apparaitra côté intérieur.
							</Tooltip>
						</span>
					</header>
					<div>
						<div className="mb-1">
							<Cylinder
								dimensionA={dimensionA}
								dimensionB={dimensionB}
								isButtonCylinder={cylinder_type_id === 2} />
						</div>
						<div className="u-flex mb-1 px-1">
							<div className="u-flex-1 mr-1">
								<Slider
									min={-cylinderDimensions.dimension_a.max}
									max={-cylinderDimensions.dimension_a.min}
									step="5"
									value={-dimensionA}
									onChange={onDimensionAChange} />
							</div>
							<div className="u-flex-1">
								<Slider
									min={cylinderDimensions.dimension_b.min}
									max={cylinderDimensions.dimension_b.max}
									step="5"
									value={dimensionB}
									disabled={cylinder_type_id === 3}
									onChange={onDimensionBChange} />
							</div>
						</div>
						<div className="u-flex u-flex--justify-around mb-1 px-1">
							<div className="u-flex u-flex--align-items-center">
								<label>Ext : </label>
								<input
									className="c-locking-form__number-field"
									type="number"
									min={cylinderDimensions.dimension_a.min}
									max={cylinderDimensions.dimension_a.max}
									step={5}
									value={dimensionA}
									onChange={onDimensionAChange}
									onBlur={onDimensionBlur.bind(null, cylinderDimensions.dimension_a.min, cylinderDimensions.dimension_a.max, "dimension_a")} />
								<span>mm</span>
							</div>
							<span className="c-locking-form__cross">X</span>
							<div className="u-flex u-flex--align-items-center">
								<label>Int : </label>
								<input
									className="c-locking-form__number-field"
									type="number"
									min={cylinderDimensions.dimension_b.min}
									max={cylinderDimensions.dimension_b.max}
									step={5}
									value={dimensionB}
									onChange={onDimensionBChange}
									onBlur={onDimensionBlur.bind(null, cylinderDimensions.dimension_b.min, cylinderDimensions.dimension_b.max, "dimension_b")} />
								<span>mm</span>
							</div>
						</div>
					</div>
				</div>
			:null}
			<div className="p-1">
				<PrimaryButton
					iconName="floppy"
					fillWidth
					submit>

					Enregistrer
				</PrimaryButton>
			</div>
		</Form>
	</div>

export default LockingForm;



// WEBPACK FOOTER //
// ./src/js/plan/lockings/LockingForm.js